<script>
  import Feature from "../feature"
  import Dimensions from "./Dimensions.svelte"
  import Context from "./Context.svelte"
  import GlyphInfo from "./GlyphInfo.svelte"
  import TabButton from "../TabButton.svelte"
  import TabButtonGroup from "../TabButtonGroup.svelte"

  export let dimensions
  export let glyph

  let mode = "dimensions"

  function setMode(event) {
    mode = event.detail.tab.toLowerCase()
  }
</script>

<div class="root">
  <div class="glyph">
    {#if mode === "dimensions"}
      <Dimensions {glyph} {dimensions} />
    {:else if mode === "context"}
      <Context {glyph} />
    {/if}
  </div>
  <div class="info">
    <GlyphInfo {glyph} />
  </div>
  {#if Feature.isEnabled("glyphContext")}
    <div class="tabs">
      <TabButtonGroup>
        <TabButton
          label={"Dimensions"}
          current={mode === "dimensions"}
          on:click={setMode}
        />
        <TabButton
          label={"Context"}
          current={mode === "context"}
          on:click={setMode}
        />
      </TabButtonGroup>
    </div>
  {/if}
</div>

<style lang="scss">
  @use "../../partials";
  .root {
    width: 100%;

    height: calc(100vh - var(--top) - var(--line-height-m));
    height: calc(100lvh - var(--top) - var(--line-height-m));

    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    grid-gap: var(--grid-column-gap);
    align-items: center;

    @include partials.media(">phone") {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 40vmin 1fr;
    }
  }

  .info {
    grid-row: 3 / -1;
    min-height: calc(var(--line-height-s) * 4);
    align-self: end;
    display: none;

    @include partials.media(">phone") {
      display: block;
    }
  }

  .tabs {
    grid-row: 3 / -1;
    align-self: end;
    justify-self: end;

    @include partials.media("<phone") {
      display: none;
    }
  }

  .glyph {
    height: 100%;
    // min-height: 300px;
    // max-height: 50vw;
    grid-column: 1 / -1;
    grid-row: 2 / 3;
  }

  .glyph > :global(*) {
    width: 100%;
    height: 100%;
  }
</style>
